<template>
  <div class="container-fluid">
    <div class="" v-if="event">
      <div class="row">
        <div class="col-12">
          <StudioCheckout
            viewButtonText="PRODUCTS.BUTTON.RETURN_TO_EVENT"
            viewRouteName="studio-event-details"
            :eventId="eventId"
          >
            <template v-slot:breadcrumbs>
              <div class="small">
                <div class="d-flex">
                  <span
                    class="back-button pointer d-md-none"
                    @click="$router.go(-1)"
                  >
                    <i class="fal fa-chevron-left"></i>
                  </span>
                  <StudioLogo class="logo-image mb-2" :studio="studio" />
                </div>
                <hr class="d-block d-md-none mt-2 mb-3 p-0" />
                <router-link
                  :to="{ name: 'studio-event-details' }"
                  class="c-coral"
                >
                  <span>{{ event.event_name }}</span>
                </router-link>
                <span class="mx-2 mx-md-3">
                  <i class="fal fa-chevron-right"></i>
                </span>
                <router-link
                  v-if="eventProducts.length > 1"
                  :to="{ name: 'studio-event-select-product' }"
                  class="c-coral"
                >
                  <span>
                    {{ $t('STUDIO.LABELS.BREADCRUMB_SELECT_PRODUCT') }}
                  </span>
                </router-link>
                <span v-if="eventProducts.length > 1" class="mx-2 mx-md-3">
                  <i class="fal fa-chevron-right"></i>
                </span>
                <span class="c-charcoal">
                  {{ $t('STUDIO.LABELS.BREADCRUMB_CHECKOUT') }}
                </span>
              </div>
            </template>
          </StudioCheckout>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import Vue from 'vue';
import { errorToMessage } from '@/core/utils/errors';
import StudioCheckout from '@/web/components/checkout/StudioCheckout';
import StudioLogo from '@/web/components/navigation/StudioLogo';
import { getStudioURL } from '@/web/router/custom-domain-utils';

export default Vue.extend({
  name: 'StudioEventProductCheckout',
  components: {
    StudioCheckout,
    StudioLogo,
  },
  computed: {
    ...mapGetters({
      event: 'event/eventDetails',
      eventProducts: 'event/eventProducts',
      studio: 'studio/currentStudio',
      isLoggedIn: 'user/isLoggedIn',
      currency: 'studio/currency',
    }),
    studioURL() {
      return getStudioURL(this.$route);
    },
    eventId() {
      return this.$route.params.event_id;
    },
    productId() {
      return this.$route.params.product_id;
    },
  },
  data() {
    return {
      loadError: null,
    };
  },
  methods: {},
  mounted() {
    this.$store
      .dispatch('event/getStudioEventDetails', {
        studioURL: this.studioURL,
        eventId: this.eventId,
      })
      .catch(error => {
        this.loadError = this.$t('EVENTS.TEXT.WHOOPS_COULD_NOT_FIND_EVENT');
        this.$notify({
          group: 'app',
          type: 'error',
          title: 'Event load failed',
          text: errorToMessage(error.response, `Request failed: ${error}`),
        });
      });
  },
});
</script>

<style lang="scss" scoped>
@import '@/web/styles/components-variables.scss';

.logo-image {
  display: block;
  height: 60px;
  width: auto;
}

.back-button {
  display: flex;
  align-items: center;
  padding: 0 16px;
  margin-left: -10px;
}
</style>
